import { IonHeader, IonToolbar } from "@ionic/react";
import React, { useEffect, useRef } from "react";
import closeIcon from "../../assets/imgs/close.svg";
import rotobotAi from "../../assets/imgs/rotobot_ai.svg";
import topRight from "../../assets/imgs/top_right_share.svg";
import center from "../../assets/imgs/center_share.svg";
import bottomLeft from "../../assets/imgs/bottom_left_share.svg";
import { useNavigate } from "react-router-dom";
import { shareContent } from "../../Services/shareContent";
import { hapticsImpactLight } from "../../lib/utils";
import { useMixpanel } from "../../Context/MixpanelContext/MixpanelProvider";

export default function ShareScreen() {
  const navigate = useNavigate();
  const Mixpanel = useMixpanel();
  const hasTrackedRef = useRef(false);

  const handleShare = async () => {
    try {
      Mixpanel.trackEvent("click_share_button", {
        name: "User clicked the share button",
      });
      hapticsImpactLight();
      await shareContent({
        title: "RotoBot AI",
        text: "AI Meets Fantasy Football",
        url: "https://apps.apple.com/us/app/rotobot-ai/id6502530085",
      });
    } catch (error) {
      console.error("Error sharing:", error);
    }
  };

  useEffect(() => {
    if (!hasTrackedRef.current) {
      Mixpanel.trackEvent("share_screen_seen_by_user", {
        name: "Share screen seen by user",
      });
      hasTrackedRef.current = true;
    }
  }, []);

  return (
    <div className="relative w-full h-screen bg-[#000513] flex flex-col  items-center text-white px-6">
      {/* Header */}
      <IonHeader className="ion-no-border modal-ion-header absolute top-0 left-0 w-full">
        <IonToolbar className="custom-toolbar">
          <div className="pr-3  flex items-center justify-between sticky top-0 z-50">
            <div
              className="cursor-pointer p-3"
              onClick={() => {
                hapticsImpactLight();
                navigate(-1);
              }}
            >
              <img src={closeIcon} alt="Close" />
            </div>
            <div className="flex-grow flex justify-center">
              <img src={rotobotAi} alt="Rotobot AI" />
            </div>
            <div className="w-[24px]"></div>
          </div>
        </IonToolbar>
      </IonHeader>

      {/* Background Images */}
      <img src={topRight} alt="Top Right" className="absolute top-0 right-0 " />
      <img
        src={bottomLeft}
        alt="Bottom Left"
        className="absolute bottom-20 left-0 "
      />

      {/* Center Image */}
      <img src={center} alt="Center Illustration" className="z-10 mt-[120px]" />

      {/* Text Content */}
      <div className="text-stat mt-6">
        <p className="text-[28px] leading-[42px] font-medium">
          Sports questions? Two minds are better than one—invite a friend!
        </p>
        <p className="text-[14px] text-white/65 mt-4 leading-[18px] font-medium">
          Get smarter insights, debate picks, and make winning decisions
          together.
        </p>
      </div>

      {/* Share Button */}
      <div
        className="fixed bottom-0 left-0 right-0 px-6"
        style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 25px)" }}
      >
        <button
          onClick={handleShare}
          className="text-[18px] font-semibold bg-white text-black w-full h-[65px] flex items-center justify-center rounded-[39px] z-10"
        >
          Share Now
        </button>
      </div>
    </div>
  );
}
